(function () {
    'use strict';

    var $bookingEngine = $('.booking-engine');

    if ($bookingEngine.length === 0) return;

    // Modules
    var Handlebars = require('handlebars');
    var Humps = require('humps');
    var Booking = require('../modules/Booking');
    var Locations = require('../modules/Locations');
    var Vehicles = require('../modules/Vehicles');
    var HandlebarsHelpers = require('../modules/HandlebarsHelpers');
    var Scroll = require('../modules/Scroll');
    var BookingCreateValidator = require('./validation/BookingCreate');

    HandlebarsHelpers.register(Handlebars);

    // Local variables
    var $vehiclesForm = $bookingEngine.find('form#vehicles-form');
    var $bookingForm = $bookingEngine.find('form#booking-form');
    var $placeBookingButton = $bookingForm.find('button');
    var $findVehiclesButton = $vehiclesForm.find('button');
    var $pricesOverlay = $bookingEngine.find('.prices-overlay');
    var $blockLoader = $bookingEngine.find('.block-loader-wrapper');
    var $paymentModal = $bookingEngine.find('#payment-modal');
    var directBooking = !!parseInt($bookingEngine.find('input[name="direct_booking"]').val());
    var vehiclesList = [];
    var chosenVehicle = null;
    var currencySymbol = '';
    var bookingParameters = {
        country: null,
        location: null,
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        age: null,
        promoCode: null,
        vehicle: null,
        extras: null,
        prices: null,
        online: null,
    };

    $bookingEngine.find('.country-selection .toggle-country-view').on('click', function (e) {
        e.preventDefault();

        var $element = $(this);
        var view = $element.data('view');

        if (view === 'list') {
            $element.data('view', 'flags');
            $element.text('Show list');
        } else {
            $element.data('view', 'list');
            $element.text('Show flags');
        }

        $bookingEngine.find('.country-selection .country-list').toggleClass('hidden');
        $bookingEngine.find('.country-selection .country-flags').toggleClass('hidden');
    });

    // Event listeners
    $bookingEngine.find('.country-selection [data-country-id]').on('click', function (e) {
        e.preventDefault();

        var $element = $(this);
        var country = $element.data('country-id');

        $element.addClass('active').siblings().removeClass('active');

        $vehiclesForm.find('input[name="country"]').val(country);

        $bookingEngine.find('.location-selection .list-group').fadeOut(400, function () {
            $bookingEngine.find('.location-selection .loader-wrapper').fadeIn(400, function () {
                Locations.get(country, renderLocations);
            });
        });

        bookingParameters.country = country;
    });

    $bookingEngine.on('click', '.location-selection .list-group a', function (e) {
        e.preventDefault();

        var $element = $(this);
        var location = $element.data('location-id');

        $element.addClass('active').siblings().removeClass('active');

        $vehiclesForm.find('input[name="location"]').val(location);
        $findVehiclesButton.removeClass('disabled');

        bookingParameters.location = location;
    });

    $vehiclesForm.on('submit', function (e) {
        e.preventDefault();

        var $form = $(this);
        var data = transformVehiclesRequest($form.serializeObject());

        $bookingEngine.find('.extras-selection-wrapper, .customer-details-wrapper').fadeOut();
        $bookingEngine.find('.vehicle-selection-wrapper').fadeOut(400, function () {
            $blockLoader.fadeIn(400, function () {
                Vehicles.get(data, renderVehicles);
            });
        });

        bookingParameters.startDate = data.start_date;
        bookingParameters.startTime = data.start_time;
        bookingParameters.endDate = data.end_date;
        bookingParameters.endTime = data.end_time;
        bookingParameters.age = data.age;
        bookingParameters.promoCode = data.promo_code;
    });

    $bookingEngine.on('click', '.vehicle-selection .vehicle button', function (e) {
        e.preventDefault();

        var $element = $(this).parents('.vehicle');
        var vehicle = $element.data('vehicle-id');

        chosenVehicle = $.grep(vehiclesList, function (v, index) {
            return vehicle == v.id;
        })[0];

        $element.addClass('selected').siblings().removeClass('selected');

        currencySymbol = chosenVehicle.currencySymbol;

        renderExtras(chosenVehicle.extras);

        var online = !!$(this).data('online');
        var priceToday = online ? chosenVehicle.total : chosenVehicle.poaDeposit;
        var priceDue = online ? 0.0 : (chosenVehicle.totalPoa - chosenVehicle.poaDeposit).toFixed(2);
        var total = online ? chosenVehicle.total : chosenVehicle.totalPoa;

        setTotals(
            priceToday,
            priceDue,
            total,
            chosenVehicle.currency,
            chosenVehicle.discount,
            chosenVehicle.originalPrice
        );

        $pricesOverlay.removeClass('hidden');

        bookingParameters.vehicle = chosenVehicle;
        bookingParameters.online = online;
    });

    $bookingEngine.on('change', '.extras-selection input, .extras-selection select', function (e) {
        var $element = $(this);

        var value = typeof $element.prop('checked') === 'undefined' ? $element.val() : $element.prop('checked') ? 1 : 0;

        resetOtherRequiredOptions($element);
        updateTotals($element.data('price'), value, $element.data('previous-multiplier'));

        $element.data('previous-multiplier', value);
    });

    BookingCreateValidator($bookingForm, function (form, e) {
        $placeBookingButton.attr('disabled', 'disabled');

        var $form = $(form);
        var data = $form.serializeObject();

        data = copyBookingParameters(data);

        if (!directBooking) {
            Booking.payment(data, function (result) {
                if (result.success) {
                    $paymentModal.find('iframe').attr('src', result.url);
                    $paymentModal.modal('show');

                    $placeBookingButton.removeAttr('disabled');
                }
            });

            return;
        }

        Booking.place(data, function (result) {
            if (result && result.success) {
                swal(
                    {
                        title: 'Done!',
                        text: `This is the reference number:
                            <div id="reference-number" class="text-center">
                                <h3>
                                    ${result.booking_reference}
                                </h3>
                            </div>`,
                        html: true,
                        type: 'success',
                    },
                    function () {
                        location.reload();
                    }
                );
            } else {
                swal({
                    title: 'Oops!',
                    text: 'Something went wrong.',
                    type: 'error',
                });

                $placeBookingButton.removeAttr('disabled');
            }
        });
    });

    // Functions
    function renderLocations(locations) {
        var template = Handlebars.compile(
            '{{# locations }}' +
                '  <a class="list-group-item" href="#" data-location-id="{{ id }}">{{ name }}</a>' +
                '{{/ locations }}'
        );
        var rendered = template({
            locations: locations,
        });

        $bookingEngine.find('.location-selection .loader-wrapper').fadeOut(400, function () {
            $bookingEngine.find('.location-selection .list-group').html(rendered).fadeIn();
        });
    }

    function renderVehicles(vehicles) {
        var source = $('#vehicle-template').html();
        var template = Handlebars.compile(source);
        var rendered = template({
            vehicles: vehicles,
        });

        vehiclesList = vehicles;

        $blockLoader.fadeOut(400, function () {
            $bookingEngine
                .find('.vehicle-selection')
                .html(rendered)
                .parents('.vehicle-selection-wrapper')
                .fadeIn(400, function () {
                    Scroll.to('.vehicle-selection', -150);
                });
        });
    }

    function renderExtras(extras) {
        var source = $('#extras-template').html();
        var template = Handlebars.compile(source);
        var rendered = template({
            extras: extras,
        });

        $bookingEngine
            .find('.extras-selection')
            .html(rendered)
            .parents('.extras-selection-wrapper')
            .fadeIn(400, function () {
                $bookingEngine.find('.customer-details-wrapper').fadeIn(400, function () {
                    Scroll.to('.extras-selection', -150);
                });
            });
    }

    function transformVehiclesRequest(data) {
        data.start_date = moment(data.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        data.end_date = moment(data.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        data.start_time = moment(data.start_time, 'h:mma').format('HH:mm');
        data.end_time = moment(data.end_time, 'h:mma').format('HH:mm');

        return data;
    }

    function setTotals(today, due, total, currency, discount, originalPrice) {
        discount = discount || 0.0;
        originalPrice = originalPrice || total;

        $pricesOverlay.find('.price-today').html(currencySymbol + today);
        $pricesOverlay.find('.price-due').html(currencySymbol + due);
        $pricesOverlay.find('.price-total').html(currencySymbol + total);

        bookingParameters.prices = {
            today: today,
            due: due,
            total: total,
            currency: currency,
            discount: discount,
            originalPrice: originalPrice,
        };
    }

    function updateTotals(price, multiplier, previousMultiplier) {
        var $priceDue = $pricesOverlay.find('.price-due');
        var $priceTotal = $pricesOverlay.find('.price-total');
        var priceDue = $priceDue.text().substring(1, $priceDue.text().length);
        var priceTotal = $priceTotal.text().substring(1, $priceTotal.text().length);

        if (isNaN(previousMultiplier)) {
            previousMultiplier = 0;
        }

        price = price.toString().replace(/,/g, '');

        var priceToAdd = -price * previousMultiplier + price * multiplier;

        priceDue = (parseFloat(priceDue) + parseFloat(priceToAdd)).toFixed(2);
        priceTotal = (parseFloat(priceTotal) + parseFloat(priceToAdd)).toFixed(2);

        $priceDue.html(currencySymbol + priceDue);
        $priceTotal.html(currencySymbol + priceTotal);

        bookingParameters.prices.due = priceDue;
        bookingParameters.prices.total = priceTotal;
    }

    function resetOtherRequiredOptions($element) {
        var group = $element.data('group');

        if (!group) return;

        $('input[data-group="' + group + '"]')
            .not($element)
            .prop('checked', false)
            .each(function (value, element) {
                $element = $(element);

                updateTotals($element.data('price'), +$element.prop('checked'), $element.data('previous-multiplier'));

                $element.data('previous-multiplier', $element.val());
            });

        $('select[data-group="' + group + '"]')
            .not($element)
            .val(0)
            .each(function (value, element) {
                $element = $(element);

                updateTotals($element.data('price'), $element.val(), $element.data('previous-multiplier'));

                $element.data('previous-multiplier', $element.val());
            });
    }

    function copyBookingParameters(formData) {
        $.extend(formData, Humps.decamelizeKeys(bookingParameters));

        formData.extras = getExtras(formData.vehicle.extras);

        return formData;
    }

    function getExtras(extras) {
        return $.map(extras, function (extra) {
            var $input = $bookingEngine.find('#' + extra.slug);
            var quantity = typeof $input.prop('checked') === 'undefined' ? $input.val() : +$input.prop('checked');
            var total = (extra.total * quantity).toFixed(2);

            if (quantity == 0) return;

            $.extend(extra, {
                quantity: quantity,
                total: total,
            });

            return extra;
        });
    }
})();



// WEBPACK FOOTER //
// ./resources/scripts/portal/components/Booking.js